import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import lang from "../../asset/Language.json"
import LotrinhNhanvien from './LotrinhNhanvien';
import BaocaoTongHop from './BaocaoTonghop';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function LinhtrinhBoard() {
  const [value, setValue] = React.useState(0);
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label={lang.lotrinh.lotrinhnhanvien} />
          <Tab label={lang.lotrinh.baocaotonghop} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <LotrinhNhanvien/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <BaocaoTongHop/>
      </TabPanel>
    </Box>
  );
}

